Workflows are visual test sequences that model user journeys through your application. Each workflow is a directed graph of nodes — login, navigate, action, assertion, wait, condition, setup, and more — connected to form a testable path.

When to use workflows:

- Critical paths: signup, checkout, billing, onboarding
- High-risk areas: features that regress often or have complex logic
- Multi-step journeys: flows spanning multiple pages or user roles

FLOW TYPES

  standard    The default. Models a single user journey end-to-end.
              Login → Navigate → Actions → Assertions → Cleanup.

  setup       A prerequisite workflow that runs before other workflows.
              Use for shared data creation or environment preparation.
              Any published workflow can be referenced as a setup step.

  seed        A data-seeding workflow that generates test data and exports
              variables for downstream workflows. Seed outputs are declared
              in the workflow definition and available as $var.{dataKey}
              in any workflow that references the seed.

  teardown    A cleanup workflow that runs after a seed workflow completes.
              Automatically invoked to remove data the seed created.

EXECUTION MODEL

  1. Login node provisions an authenticated browser session
  2. Nodes execute in sequence (or branch at condition nodes)
  3. Each action node interacts with the live application
  4. Assertions verify expected outcomes
  5. Additional login nodes switch to a different user — each starts a
     new segment with a fresh session (great for multi-role testing)
  6. Wait nodes pause execution (minutes, hours, days) — also creating
     segments. After a wait, a login re-establishes the session.
  7. On completion, the run is marked success or failure

VERSION HISTORY

  Workflows maintain version history. Publishing creates a versioned
  snapshot. Previous versions can be previewed or restored to draft.
  Setup nodes reference a specific published version of another workflow.